/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudResourceSecurityProperties } from '../models/CloudResourceSecurityProperties';

export class SaveCloudResourceSecurityPropertiesRequest {
  'securityProperties'?: CloudResourceSecurityProperties | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "securityProperties",
      "baseName": "securityProperties",
      "type": "CloudResourceSecurityProperties",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SaveCloudResourceSecurityPropertiesRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

